import React from 'react';
import { Switch, Route } from 'react-router-dom';

import Devices from '../NewDevice/index';
import EditDevices from '../EditDevice';
import EditSensor from '../Sensor';
import Indicator from '../Indicator';

const Routes: React.FC = () => {
  return (
    <Switch>
      <Route path="/app/device" exact component={Devices} />
      <Route path="/app/device/:id" exact component={EditDevices} />
      <Route path="/app/device/sensor/:id" exact component={EditSensor} />
      <Route path="/app/device/:id/indicator" exact component={Indicator} />
      <Route path="/app/device/:id/indicator/:indicator" exact component={Indicator} />
    </Switch>
  );
};

export default Routes;
